import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import ClaraResource from '@/modules/ai/resources/ClaraResource';
import { StreamQuestionParams } from '@/modules/ai/services/interfaces/StreamQuestionParams';

export class ClaraStreamService extends BaseService {
  resource: typeof ClaraResource;

  constructor() {
    super();
    this.resource = ClaraResource;
  }

  async openStream(params: StreamQuestionParams): Promise<EventSource> {
    const response: Record<string, string> = await this.resource.getStreamUrl(params);
    return new EventSource(response.streamUrl);
  }
}

export default new ClaraStreamService();
